<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Documentos adjuntos - {{this.numint}}</h3>
    <button type="button" class="close" aria-label="Close" (click)="cancelar()" tabindex="211">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form>
        <div class="row">
            <div class="col-md-12">

                <div class="row mt-3" style="margin-top:15px !important">
                    <div class="col-md-12">
                        <!-- <button tabindex="15" class="btn btn-rounded btn-info mr-3" type="button" id="loadFileXml" value="loadXml"
                        onclick="document.getElementById('file').click();"><i class="fas fa-upload"
                            style="margin-right: .3rem"></i> Importar documento</button> -->
                        <button tabindex="15" class="btn btn-rounded btn-info mr-3" type="button" id="loadFileXml"
                            value="loadXml" onclick="document.getElementById('file').click();"><i class="fas fa-upload"
                                style="margin-right: .3rem"></i> Importar archivo</button>


                        <input type="file" style="display:none;" id="file" name="file"
                            accept=".jpg,.pdf,.xml,.xlsx,.xlsm" multiple (change)="handleFileInput($event.target.files)"
                            (click)="onInputClick($event)" />

                        <!-- <input  #fileUpload type="file" id="file" accept=".jpg,.pdf"
                                            (change)="uploadImage($event)">

                                                                        
                            <button [disabled]="boolguardar" class="btn btn-rounded btn-info m-b-15" (click)="agregarImagen()"
                            style="width: 115px; margin-right: 50px; margin-top: 10px;"
                            tabindex="14"><i
                                class="fa fa-save"></i>&nbsp; Guardar</button> -->
                        <br>
                        <br>

                        <!-- <input type="text" placeholder="Buscar ..." class="form-control col-md-6" (keydown)="onChange($event.target.value)" [(ngModel)]="csearchTerm" name="csearchTerm"> -->
                        <div class="table-responsive" style="height: 55vh;">
                            <table class="table table-sm table-striped table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th class="text-center"></th>
                                        <th>Item</th>
                                        <th>Formato</th>
                                        <th>Nombre</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="cursor" *ngFor="let lst of doc_adjuntos">
                                        <td style="text-align: center;">
                                            <div class="btn-group dropright" ngbDropdown container="body" role="group"
                                                aria-label="Button group with nested dropdown"
                                                style="margin: 0px; padding: 0px;">
                                                <button class="btn btn-sm" ngbDropdownToggle
                                                    style="margin: 0px; padding: 0px;">
                                                    <i class=" fas fa-align-left"></i>
                                                </button>
                                                <ul class="dropdown-menu" ngbDropdownMenu>
                                                    <li>
                                                        <a class="dropdown-item" href="javascript:;" style="width: 84%;"
                                                            (click)="eliminar(lst)">
                                                            <i style="width: 84%;" class="fas fa-trash-alt"
                                                                style="margin-right: .3rem"></i>Eliminar</a>
                                                    </li>
                                                    <li>
                                                        <a class="dropdown-item" href="javascript:;" style="width: 84%;"
                                                            (click)="descargar(lst)">
                                                            <i style="width: 84%;" class="fas fa-download"
                                                                style="margin-right: .3rem"></i>Descargar</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td style="white-space: nowrap;" class="text-left">{{lst.id}}</td>
                                        <td style="white-space: nowrap;" class="text-left">{{lst.formato}}</td>
                                        <td style="text-align: right;" class="text-left">{{lst.nombre}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

</div>
<div class="modal-footer">
    <div class="input-group m-t-15 d-flex justify-content-end">

        <!-- <button type="button" *ngIf="!editar"  [disabled]="!(this.detalleadicionar.length > 0)"
         class="btn btn-rounded btn-success" tabindex="208" (click)="guardar()">
            <i class="fa fa-plus"></i> Adicionar </button>

        <button type="button" *ngIf="editar" [disabled]="!(this.detalleadicionar.length > 0)"
         class="btn btn-rounded btn-info" tabindex="208" (click)="guardar()">
            <i class="fa fa-check"></i> Actualizar </button> -->

        <button type="button" class="btn btn-rounded btn-success m-b-15" tabindex="209" (click)="cancelar()"
            data-bs-toggle="tooltip" title="Cancelar: Esc"><i class="fas fa-angle-double-right"></i> Continuar</button>
    </div>
</div>